import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { DirtyFormChecker } from "src/app/shared/routeguards/DirtyFormChecker";
import { ToastService } from "src/app/shared/services/toast.service";
import { PermissionsAdminComponent } from "../permissions-admin/permissions-admin.component";
import { PermissionsAppointmentConciergeComponent } from "../permissions-appointment-concierge/permissions-appointment-concierge.component";
import { PermissionsLobbyComponent } from "../permissions-lobby/permissions-lobby.component";
import { PermissionsReportsComponent } from "../permissions-reports/permissions-reports.component";
import { PermissionAdmin } from "../shared/models/admin.permission.model";
import { PermissionAppointments } from "../shared/models/appointment.permission.model";
import { PermissionLobby } from "../shared/models/lobby.permission.model";
import { PermissionGroupAddModel } from "../shared/models/permission.add.model";
import { PermissionUpdate } from "../shared/models/permission.update.model";
import { PermissionReport } from "../shared/models/report.permission.model";
import { PermissionsServiceService } from "../shared/services/permissions-service.service";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { AppState } from "src/app/shared/models/store models/app-state.interface";
import {
  getACLicenseStatus,
  getCurrentTenant,
  getLTLicenseStatus,
  GetUserPermissionList,
} from "src/app/state";
import { CheckPermissionGroupName } from "../shared/models/CheckPeermissionGroup";
import { ViewMode } from "src/app/shared/enums/view-mode.enum";
import { IPermissionEdit } from "../shared/models/IPermissionEdit";
import { TranslationLoaderFacade } from "../../localization/translation-loader.facade";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-permissions-edit",
  templateUrl: "./permissions-edit.component.html",
  styleUrls: ["./permissions-edit.component.scss"],
})
export class PermissionsEditComponent
  implements OnInit, OnDestroy, AfterViewInit, DirtyFormChecker
{
  @Output() dirtyEmitter = new EventEmitter<boolean>(false);
  public pageTitle: string = "";
  public permissionGroupEdit!: FormGroup;
  public allPermissionReferences = {
    data: [] as any[],
    groupPermission: [] as number[],
  };
  public permissionByGroup: any;
  public isDirty: boolean = false;
  public hasLTLicense: boolean = false;
  public hasACLicense: boolean = false;
  private subscriptions = new Subscription();
  public canUncheckNotification: boolean = true;

  public permissionTitleTranslate: any;
  public permissionEditNotificationText: string | undefined;
  public permissionEditTexts: any;

  public uptodateAdminObject: PermissionAdmin = new PermissionAdmin();
  public uptodateLobbyObject: PermissionLobby = new PermissionLobby();
  public uptodateReportObject: PermissionReport = new PermissionReport();
  public uptodateAppointmentsObject: PermissionAppointments =
    new PermissionAppointments();
  public permissionGroups: number[] = [];
  public userPermissionList: number[] = [];
  public isViewOnly: boolean = false;
  public notificationGroupCheckBoxDisable: boolean = false;
  public disabledSelectAll: boolean = false;

  @ViewChild(PermissionsAdminComponent) admin: PermissionsAdminComponent =
    {} as PermissionsAdminComponent;
  @ViewChild(PermissionsLobbyComponent) lobby: PermissionsLobbyComponent =
    {} as PermissionsLobbyComponent;
  @ViewChild(PermissionsAppointmentConciergeComponent)
  appointment: PermissionsAppointmentConciergeComponent =
    {} as PermissionsAppointmentConciergeComponent;
  @ViewChild(PermissionsReportsComponent) report: PermissionsReportsComponent =
    {} as PermissionsReportsComponent;

  @ViewChild("acc") public accordion?: any;

  isACLicenseEnabled$: Observable<boolean> = new Observable<boolean>();
  isLTLicenseEnabled$: Observable<boolean> = new Observable<boolean>();

  tenantId: number = 0;
  permissionList: number[] = [];
  permissionListToRemove: number[] = [];

  public isEditting: any;
  public timeout: any = null;

  private panels = {
    administrativePermissions: "ngb-panel-0",
    lobbyPermissions: "ngb-panel-2",
    reportsPermissions: "ngb-panel-3",
    uKGAppointmentsPermissions: "ngb-panel-4",
  };

  public activeIds: string[] = [this.panels.administrativePermissions];

  public isSubsectionsValid: boolean = false;
  public isUkgDefaultGroup: boolean = false;

  public anyPermissionSelected: boolean = false;

  public saveButtonTooltip: string = "";

  constructor(
    public fb: FormBuilder,
    public permissionService: PermissionsServiceService,
    public toastService: ToastService,
    private router: Router,
    private store: Store<AppState>,
    private translationLoaderFacade: TranslationLoaderFacade,
    private translateService: TranslateService
  ) {
    this.createPermissionUserGroupForm();

    this.translateService
      .get([
        "_Permission_Grid_Add_Permission_Group_Text_",
        "_Permission_View_Permission_Group_Ts_Text_",
        "_Permission_Edit_Permission_Group_Ts_Text_",
        "_Permission_Edit_Notification_Group_Title_Text_",
        "_Permission_Permission_Group_Already_In_Use_Ts_Text_",
      ])
      .subscribe((translations) => {
        (this.permissionTitleTranslate = [
          {
            id: 1,
            value: translations["_Permission_Grid_Add_Permission_Group_Text_"],
          },
          {
            id: 2,
            value: translations["_Permission_View_Permission_Group_Ts_Text_"],
          },
          {
            id: 3,
            value: translations["_Permission_Edit_Permission_Group_Ts_Text_"],
          },
        ]),
          (this.permissionEditNotificationText =
            translations["_Permission_Edit_Notification_Group_Title_Text_"]),
          (this.permissionEditTexts = [
            translations[
              "_Permission_Permission_Group_Already_In_Use_Ts_Text_"
            ],
          ]);
      });
  }

  ngOnInit(): void {
    this.isSubsectionsValid = true;
    this.isUkgDefaultGroup = false;

    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (!allUserPermissions) {
        throw Error("allUserPermissions is undefined!");
      }
      this.userPermissionList = allUserPermissions;
    });

    this.getAllPermissions();

    this.isLTLicenseEnabled$ = this.store.select(getLTLicenseStatus);
    this.isACLicenseEnabled$ = this.store.select(getACLicenseStatus);

    this.subscriptions.add(
      this.isLTLicenseEnabled$.subscribe((data: boolean) => {
        this.hasLTLicense = data;
      })
    );

    this.subscriptions.add(
      this.isACLicenseEnabled$.subscribe((data: boolean) => {
        this.hasACLicense = data;
      })
    );

    this.subscriptions.add(
      this.store.select(getCurrentTenant).subscribe((tenant) => {
        if (tenant) {
          this.tenantId = tenant.tenantID;
        }
      })
    );

    this.permissionService
      .getEdittingPermissionCategory()
      .subscribe((permissionData) => {
        if (permissionData) {
          this.canUncheckNotification = permissionData.canUncheckNotification;
        }
      });

    this.permissionSelected();
  }

  ngAfterViewInit() {}

  /**
   * Set page headers
   */
  setPageHeader() {
    this.permissionService
      .getEdittingPermissionCategory()
      .subscribe((permissionData) => {
        if (permissionData) {
          if (permissionData?.viewMode === ViewMode.View) {
            this.pageTitle = `${this.permissionTitleTranslate[1].value}  ${permissionData.permissionUserGroupName}`;
          } else {
            this.pageTitle = `${this.permissionTitleTranslate[2].value}  ${permissionData.permissionUserGroupName}`;
          }
        } else {
          this.pageTitle = `${this.permissionTitleTranslate[0].value}`;
        }
      });
  }

  /**
   * Create permission group form
   */
  createPermissionUserGroupForm() {
    this.permissionGroupEdit = this.fb.group({
      permissionGroupName: [null, [Validators.required]],
      notificationGroup: [false, []],
      selectAllPermissions: [false, []],
    });
  }

  /**
   * Get Permission By Group Id
   */
  public getPermissionByGroupId(event: any) {
    this.permissionService
      .getPermissionByGroupId(event)
      .subscribe((permissionByGroupId) => {
        this.permissionByGroup = permissionByGroupId;
        this.permissionGroupEdit.patchValue({
          permissionGroupName: this.permissionByGroup.permissionGroupName,
          notificationGroup: this.permissionByGroup.notificationGroup,
        });
      });
  }

  /**
   * Get All permission references
   */
  public getAllPermissions() {
    this.permissionService
      .getAllPermissions()
      .subscribe((allPermissionReferences) => {
        this.permissionService
          .getEdittingPermissionCategory()
          .subscribe((isEditting) => {
            this.isViewOnly =
              isEditting?.viewMode === ViewMode.View ? true : false;

            if (isEditting) {
              if (isEditting.notificationGroup) {
                this.collapseAccordin();
              }
              this.isEditting = isEditting;
              this.getPermissionUserGroupInformation(allPermissionReferences);
              this.setPageHeader();
            } else {
              this.isEditting = null;
              let availablePermissionList: any[] = [];
              for (let v of allPermissionReferences) {
                if (this.userPermissionList?.includes(v.permissionId)) {
                  v.enabled = true;
                } else {
                  v.enabled = false;
                }

                availablePermissionList.push(v);
              }
              this.allPermissionReferences = {
                data: availablePermissionList,
                groupPermission: [],
              };
              this.disabledSelectAll = this.setUniversalSelectAllStatus(
                this.allPermissionReferences.data
              );
              this.setPageHeader();
            }
          });
      });
  }

  /**
   * Triggers when admin object update
   * @param object
   */
  public onAdminChildObjectUpdate(object: PermissionAdmin) {
    this.uptodateAdminObject = object;
    this.permissionSelected();
  }
  /**
   * Triggers when lobby object updates
   * @param object
   */
  public onLobbyChildObjectUpdate(object: PermissionLobby) {
    this.uptodateLobbyObject = object;
    this.permissionSelected();
  }

  /**
   * Triggers when report object updates
   * @param object
   */
  public onReportChildObjectUpdate(object: PermissionReport) {
    this.uptodateReportObject = object;
    this.permissionSelected();
  }

  /**
   * Triggers when appointment object updates
   * @param object
   */
  public onAppointmentsObjectUpdate(object: PermissionAppointments) {
    this.uptodateAppointmentsObject = object;
    this.validateSubsections();
    this.permissionSelected();
  }

  /**
   * Check permission group name exists
   */
  public checkValidty() {
    this.isDirty = true;
    let value = this.permissionGroupEdit.get("permissionGroupName")!.value;
    let isNotification =
      this.permissionGroupEdit.get("notificationGroup")!.value;

    if (
      this.permissionGroupEdit
        .get("permissionGroupName")!
        .hasError("permissionGroupNameExisting")
    ) {
      this.permissionGroupEdit.get("permissionGroupName")!.setErrors(null);
    }

    this.permissionService
      .getEdittingPermissionCategory()
      .subscribe((isEdditing) => {
        if (value !== null && value !== "") {
          let permissionObject = new CheckPermissionGroupName();
          permissionObject.permissionId = isEdditing
            ? isEdditing.permissionGroupId
            : 0;
          permissionObject.permissionName = value;
          permissionObject.isNotification = isNotification;
          this.permissionService
            .checkForPermissionGroupNameAlreadyExsists(permissionObject)
            .subscribe((isExisting) => {
              if (!isExisting.valid) {
                this.permissionGroupEdit
                  .get("permissionGroupName")!
                  .setErrors({
                    permissionGroupNameExisting: `${this.permissionEditTexts[0]}`,
                  });
              }
            });
          this.setSaveButtonTooltip();
        }
      });
  }
  /**
   * Triggers when user clicks on save button
   */
  public save() {
    this.getAllUpdatedPermissions();
    this.permissionService
      .getEdittingPermissionCategory()
      .subscribe((isEdditing) => {
        let permissionGroupName = this.removeWhiteSpaces(
          this.permissionGroupEdit.get("permissionGroupName")!.value
        );
        if (isEdditing) {
          let permissionUdpdate = new PermissionUpdate();
          permissionUdpdate.previousGroupIsNotification =
            this.isEditting.notificationGroup;
          permissionUdpdate.notificationGroup =
            this.permissionGroupEdit.get("notificationGroup")?.value;
          permissionUdpdate.permissionGroupId = isEdditing.permissionGroupId;
          permissionUdpdate.permissionGroupName = permissionGroupName!;
          permissionUdpdate.notificationGroup
            ? (permissionUdpdate.permissions = [])
            : (permissionUdpdate.permissions = this.mapPermissions());
          permissionUdpdate.notificationGroup
            ? (permissionUdpdate.permissionsToRemove = [])
            : (permissionUdpdate.permissionsToRemove =
                this.mapRemovePermissions());
          this.permissionService
            .submitUpdatedPermissions(permissionUdpdate)
            .subscribe(
              (data) => {
                this.toastService.showSuccess(
                  "_General_Changes_Saved_Successfully_Ts_Text_"
                );
                this.permissionGroupEdit.reset();
                this.router.navigate(["admin/permissions"]);
                this.isDirty = false;
              },
              (error) => {
                console.log("An error occurred updating permission group");
              }
            );
        } else {
          let permissionAdd = new PermissionGroupAddModel();
          permissionAdd.notificationGroup =
            this.permissionGroupEdit.get("notificationGroup")!.value;
          permissionAdd.permissionGroupName = permissionGroupName!;
          permissionAdd.permissions = this.mapPermissions();
          this.permissionService
            .createPermissionsGroups(permissionAdd)
            .subscribe(
              (data) => {
                this.toastService.showSuccess(
                  "_Permission_Permission_Group_Created_Successfully_Ts_Text_"
                );
                this.permissionGroupEdit.reset();
                this.router.navigate(["admin/permissions"]);
                this.isDirty = false;
              },
              (error) => {
                console.log("An error occurred creating permission group");
              }
            );
        }
      });
  }

  /**
   * Get all permission updates
   */
  public getAllUpdatedPermissions() {
    this.admin.publishUpdatedObject();
    if (this.hasLTLicense) {
      this.lobby.publishUpdatedObject();
      this.report.publishUpdatedObject();
    }
    if (this.hasACLicense) {
      this.appointment.publishUpdatedObject();
    }
  }

  /**
   * Maps all permission objects Id to Array
   * @returns
   */
  public mapPermissions() {
    //Admin
    this.analyzePermission(this.uptodateAdminObject.General);
    this.analyzePermission(this.uptodateAdminObject.Location);
    this.analyzePermission(
      this.uptodateAdminObject.ViewAddEditDeleteProductCategory
    );
    this.analyzePermission(this.uptodateAdminObject.ProductAndService);
    this.analyzePermission(this.uptodateAdminObject.Groups);
    this.analyzePermission(this.uptodateAdminObject.Users);
    this.analyzePermission(this.uptodateAdminObject.Members);

    // this set of permissions is allowed on the default client (with tenantId = 1) only
    this.analyzePermission(this.uptodateAdminObject.Clients, this.tenantId);

    if (this.hasLTLicense) {
      //Admin
      this.analyzePermission(this.uptodateAdminObject.ViewGlobalAlerts);
      this.analyzePermission(this.uptodateAdminObject.Kiosk);
      //Lobby
      this.analyzePermission(this.uptodateLobbyObject.General);
      this.analyzePermission(this.uptodateLobbyObject.Checklist);
      this.analyzePermission(this.uptodateLobbyObject.Lwa);
      this.analyzePermission(this.uptodateLobbyObject.TextConfiguration);
      //Report
      this.analyzePermission(this.uptodateReportObject.LobbyActivity);
      this.analyzePermission(this.uptodateReportObject.LobbyEdit);
    }

    if (this.hasACLicense) {
      //appointment
      this.analyzePermission(this.uptodateAppointmentsObject.Administration);
      this.analyzePermission(this.uptodateAppointmentsObject.Appointements);
      this.analyzePermission(this.uptodateAppointmentsObject.ViewActionCenter);
      // AC Campaigns settings
      this.analyzePermission(this.uptodateAppointmentsObject.Campaigns);
      // AC Event settings
      this.analyzePermission(this.uptodateAppointmentsObject.Events);
      this.analyzePermission(this.uptodateAppointmentsObject.Reports);
    }

    return this.permissionList;
  }

  /**
   *  push checked permission ids to this.permissionList
   */
  private analyzePermission(
    permission: Record<string, any>,
    tenantId?: number
  ) {
    if (tenantId == 1) {
      for (const subPermission in permission) {
        if (
          permission.hasOwnProperty(subPermission) &&
          permission[subPermission].Selected
        ) {
          this.permissionList.push(permission[subPermission].Id);
        }
      }
    } else {
      for (const subPermission in permission) {
        if (
          permission.hasOwnProperty(subPermission) &&
          permission[subPermission].Selected &&
          permission[subPermission].Enabled
        ) {
          this.permissionList.push(permission[subPermission].Id);
        }
      }
    }
  }

  private analyzePermission2(permission: Record<string, any>) {
    for (const subPermission in permission) {
      if (
        permission.hasOwnProperty(subPermission) &&
        permission[subPermission].Selected &&
        permission[subPermission].Enabled
      ) {
        this.permissionList.push(permission[subPermission].Id);
      }
    }
  }

  /**
   * Fetch permission group infomation
   */
  getPermissionUserGroupInformation(event: any) {
    this.permissionService
      .getEdittingPermissionCategory()
      .subscribe((permissionEditingData) => {
        let permissionUserGroup = {
          permissionGroupId: permissionEditingData.permissionGroupId,
          notificationGroup: permissionEditingData.notificationGroup,
          permissionUserGroupName:
            permissionEditingData.permissionUserGroupName,
          canUncheckNotification: permissionEditingData.canUncheckNotification,
        };
        this.permissionService
          .getPermissionByGroupId(permissionUserGroup)
          .subscribe((allPermissionUserGroupData) => {
            this.permissionGroups = allPermissionUserGroupData.groupPermissions;
            this.allPermissionReferences = {
              data: event,
              groupPermission: this.permissionGroups,
            };
            //  this.allPermissionReferences['groupPermission'] = allPermissionUserGroupData.groupPermissions;
            this.disabledSelectAll = this.setUniversalSelectAllStatus(
              this.allPermissionReferences.data
            );
            this.setValuesTothePermissionForm(allPermissionUserGroupData);
          });
      });
  }

  /**
   * Set Values to form group
   * @param permissionUserGroupData
   */
  setValuesTothePermissionForm(permissionUserGroupData: any) {
    this.permissionGroupEdit.patchValue({
      permissionGroupName: permissionUserGroupData.permissionGroupName,
      notificationGroup: permissionUserGroupData.notificationGroup,
    });
    this.checkIsUkgDefaultGroup(permissionUserGroupData);
    if (
      permissionUserGroupData.isEditable == false ||
      this.isViewOnly == true ||
      this.canUncheckNotification == false
    ) {
      this.notificationGroupCheckBoxDisable = true;
    } else {
      this.notificationGroupCheckBoxDisable = false;
    }
  }

  /**
   * Checks for unsaved data
   * @returns
   */
  public hasUnsavedData(): boolean {
    return this.isDirty;
  }

  /**
   * Navigate to permission grid
   */
  gotoPermissionGrid() {
    this.router.navigate(["admin/permissions"]);
  }

  /**
   * Update the Form dirty event
   * @param event
   */
  public updateFormDirty(event: boolean) {
    this.isDirty = event;
  }

  public valueChange() {
    var $this = this;
    if (this.permissionGroupEdit.get("notificationGroup")!.value == true) {
      this.collapseAccordin();
      this.permissionGroupEdit.patchValue({ selectAllPermissions: false });
      this.isDirty = true;
    } else {
      this.isDirty = false;
    }
    $this.checkValidty();
  }

  private collapseAccordin() {
    this.accordion?.collapse("ngb-panel-0");
    this.accordion?.collapse("ngb-panel-2");
    this.accordion?.collapse("ngb-panel-3");
    this.accordion?.collapse("ngb-panel-4");
  }

  ngOnDestroy() {
    this.permissionService.setEdittingPermissionCategory(null);
    this.subscriptions.unsubscribe();
  }

  private validateSubsections() {
    this.isSubsectionsValid =
      this.uptodateAppointmentsObject.ViewActionCenter.isInputValid;
  }

  private checkIsUkgDefaultGroup(permissionUserGroupData: any): void {
    if (
      this.isViewOnly &&
      permissionUserGroupData.permissionGroupName === "FMSI Default Group"
    ) {
      // If the record is of FMSI Default Group then disable the edit options
      // Otherwise depend on the permission level to edit functionality
      this.isUkgDefaultGroup = true;

      this.permissionGroupEdit.patchValue({
        selectAllPermissions: true,
      });
      this.permissionGroupEdit.get("selectAllPermissions")!.disable();
    } else {
      if (!this.disabledSelectAll)
        this.permissionGroupEdit.get("selectAllPermissions")!.enable();
    }
    this.checkSectionsSelectAll();
  }

  public onKeySearch(event: any) {
    this.permissionGroupEdit
      .get("permissionGroupName")!
      .setValue(
        this.removeWhiteSpaces(
          this.permissionGroupEdit.get("permissionGroupName")!.value,
          true,
          false
        )
      );
    clearTimeout(this.timeout);
    var $this = this;
    this.timeout = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.checkValidty();
      }
    }, 1000);
  }

  private permissionSelected() {
    if (
      this.atLeastOnePermissionSelected(this.uptodateAdminObject?.Clients) ||
      this.atLeastOnePermissionSelected(this.uptodateAdminObject?.General) ||
      this.atLeastOnePermissionSelected(this.uptodateAdminObject?.Groups) ||
      this.atLeastOnePermissionSelected(this.uptodateAdminObject?.Kiosk) ||
      this.atLeastOnePermissionSelected(this.uptodateAdminObject?.Location) ||
      this.atLeastOnePermissionSelected(this.uptodateAdminObject?.Members) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAdminObject?.ProductAndService
      ) ||
      this.atLeastOnePermissionSelected(this.uptodateAdminObject?.Users) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAdminObject?.ViewAddEditDeleteProductCategory
      ) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAdminObject?.ViewGlobalAlerts
      ) ||
      this.atLeastOnePermissionSelected(this.uptodateLobbyObject?.General) ||
      this.atLeastOnePermissionSelected(this.uptodateLobbyObject?.Checklist) ||
      this.atLeastOnePermissionSelected(this.uptodateLobbyObject?.Lwa) ||
      this.atLeastOnePermissionSelected(
        this.uptodateLobbyObject?.TextConfiguration
      ) ||
      this.atLeastOnePermissionSelected(
        this.uptodateReportObject?.LobbyActivity
      ) ||
      this.atLeastOnePermissionSelected(this.uptodateReportObject?.LobbyEdit) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAppointmentsObject?.Administration
      ) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAppointmentsObject?.Appointements
      ) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAppointmentsObject?.Campaigns
      ) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAppointmentsObject?.Events
      ) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAppointmentsObject?.Reports
      ) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAppointmentsObject?.System
      ) ||
      this.atLeastOnePermissionSelected(
        this.uptodateAppointmentsObject?.ViewActionCenter
      )
    ) {
      this.anyPermissionSelected = true;
    } else {
      this.anyPermissionSelected = false;
    }
    this.setSaveButtonTooltip();
  }

  private atLeastOnePermissionSelected(value: any): boolean {
    let isSelected: boolean = false;
    if (value != undefined) {
      let propertyList = Object.values(value).filter(
        (x) => typeof x === "object"
      );
      propertyList.forEach((property) => {
        let permsision = property as IPermissionEdit;
        if (permsision.Enabled && permsision.Selected) {
          isSelected = true;
        }
      });
    }
    return isSelected;
  }

  private setSaveButtonTooltip() {
    if (
      this.permissionGroupEdit.valid &&
      !this.anyPermissionSelected &&
      this.permissionGroupEdit.get("notificationGroup")!.value == false
    ) {
      this.saveButtonTooltip =
        "_Permission_Edit_Select_Permission_To_Save_Text_";
    } else {
      this.saveButtonTooltip = "";
    }
  }

  private removeWhiteSpaces(
    text: string,
    fromBegin: boolean = true,
    fromEnd: boolean = true
  ): string {
    if (text !== null) {
      if (fromBegin && fromEnd) {
        return text.replace(/^\s+|\s+$/gm, "");
      } else if (fromBegin) {
        return text.replace(/^\s+/gm, "");
      } else if (fromBegin) {
        return text.replace(/\s+$/gm, "");
      }
    }

    return text;
  }

  public valueChangeBySelectAll(e: Event) {
    const target = e.target as HTMLInputElement;
    let isSelectAll = target.checked;

    if (
      this.uptodateAdminObject.General.dataImportExport.Enabled &&
      this.uptodateAdminObject.General.viewEditLocalization.Enabled &&
      this.uptodateAdminObject.General.viewEditSystemConfiguration.Enabled
    ) {
      this.uptodateAdminObject.General.selectAll = isSelectAll;
    }

    if (
      this.uptodateAdminObject.Clients.addClients.Enabled &&
      this.uptodateAdminObject.Clients.changeClients.Enabled &&
      this.uptodateAdminObject.Clients.viewClients.Enabled
    ) {
      this.uptodateAdminObject.Clients.selectAll = isSelectAll;
    }

    if (
      this.uptodateAdminObject.Location.activateDeactivateLocations.Enabled &&
      this.uptodateAdminObject.Location.addLocations.Enabled &&
      this.uptodateAdminObject.Location.editLocations.Enabled &&
      this.uptodateAdminObject.Location.viewLocations.Enabled
    ) {
      this.uptodateAdminObject.Location.selectAll = isSelectAll;
    }

    if (
      this.uptodateAdminObject.ProductAndService.addProductsServices.Enabled &&
      this.uptodateAdminObject.ProductAndService.editBasicProductAndServices
        .Enabled &&
      this.uptodateAdminObject.ProductAndService.editProductsAndServices
        .Enabled &&
      this.uptodateAdminObject.ProductAndService.viewProductsServices.Enabled &&
      this.uptodateAdminObject.ProductAndService
        .activateDeactivateProductsServices.Enabled &&
      this.uptodateAdminObject.ProductAndService.deleteProductsServices.Enabled
    ) {
      this.uptodateAdminObject.ProductAndService.selectAll = isSelectAll;
    }

    if (
      this.uptodateAdminObject.ViewAddEditDeleteProductCategory
        .viewAddEditDeleteProductCategory.Enabled
    ) {
      this.uptodateAdminObject.ViewAddEditDeleteProductCategory.selectAll =
        isSelectAll;
    }

    if (
      this.uptodateAdminObject.Groups.addPermissionGroups.Enabled &&
      this.uptodateAdminObject.Groups.editPermissionGroups.Enabled &&
      this.uptodateAdminObject.Groups.viewPermissionGroups.Enabled &&
      this.uptodateAdminObject.Groups.deletePermissionGroups.Enabled
    ) {
      this.uptodateAdminObject.Groups.selectAll = isSelectAll;
    }

    if (
      this.uptodateAdminObject.Users.addUsers.Enabled &&
      this.uptodateAdminObject.Users.deleteUsers.Enabled &&
      this.uptodateAdminObject.Users.editUsers.Enabled &&
      this.uptodateAdminObject.Users.viewUsers.Enabled
    ) {
      this.uptodateAdminObject.Users.selectAll = isSelectAll;
    }

    if (
      this.uptodateAdminObject.ViewGlobalAlerts.addGlobalAlerts.Enabled &&
      this.uptodateAdminObject.ViewGlobalAlerts.deleteGlobalAlerts.Enabled &&
      this.uptodateAdminObject.ViewGlobalAlerts.editGlobalAlerts.Enabled &&
      this.uptodateAdminObject.ViewGlobalAlerts.viewAddEditDeleteMyAlerts
        .Enabled &&
      this.uptodateAdminObject.ViewGlobalAlerts.viewGlobalAlerts.Enabled
    ) {
      this.uptodateAdminObject.ViewGlobalAlerts.selectAll = isSelectAll;
    }

    if (
      this.uptodateAdminObject.Kiosk.addKioskConfiguration.Enabled &&
      this.uptodateAdminObject.Kiosk.deleteKioskConfiguration.Enabled &&
      this.uptodateAdminObject.Kiosk.editKioskConfiguration.Enabled &&
      this.uptodateAdminObject.Kiosk.viewKioskConfiguration.Enabled
    ) {
      this.uptodateAdminObject.Kiosk.selectAll = isSelectAll;
    }

    if (this.hasLTLicense) {
      if (
        this.uptodateLobbyObject.General.editLobby.Enabled &&
        this.uptodateLobbyObject.General.forceSignOutUsers.Enabled &&
        this.uptodateLobbyObject.General.viewCentralViews.Enabled &&
        this.uptodateLobbyObject.General.accessAllQueues.Enabled
      ) {
        this.uptodateLobbyObject.General.selectAll = isSelectAll;
      }

      if (
        this.uptodateLobbyObject.Checklist.addChecklist.Enabled &&
        this.uptodateLobbyObject.Checklist.deleteChecklist.Enabled &&
        this.uptodateLobbyObject.Checklist.editCheckList.Enabled &&
        this.uptodateLobbyObject.Checklist.viewChecklist.Enabled
      ) {
        this.uptodateLobbyObject.Checklist.selectAll = isSelectAll;
      }

      if (
        this.uptodateLobbyObject.Lwa.lwaAdd.Enabled &&
        this.uptodateLobbyObject.Lwa.lwaDelete.Enabled &&
        this.uptodateLobbyObject.Lwa.lwaEdit.Enabled &&
        this.uptodateLobbyObject.Lwa.lwaView.Enabled
      ) {
        this.uptodateLobbyObject.Lwa.selectAll = isSelectAll;
      }

      if (
        this.uptodateLobbyObject.TextConfiguration.textConfigEdit.Enabled &&
        this.uptodateLobbyObject.TextConfiguration.textConfigEnable.Enabled &&
        this.uptodateLobbyObject.TextConfiguration.textConfigView.Enabled
      ) {
        this.uptodateLobbyObject.TextConfiguration.selectAll = isSelectAll;
      }
    }

    if (this.hasLTLicense) {
      if (
        this.uptodateReportObject.LobbyActivity.viewLobbyActivity.Enabled &&
        this.uptodateReportObject.LobbyActivity.shareTemplateLobbyActivity
          .Enabled &&
        this.uptodateReportObject.LobbyActivity.deleteTemplateLobbyActivity
          .Enabled &&
        this.uptodateReportObject.LobbyActivity.viewStaffSignInOutReport.Enabled
      ) {
        this.uptodateReportObject.LobbyActivity.selectAll = isSelectAll;
      }

      if (
        this.uptodateReportObject.LobbyEdit.editLobbyEditReports.Enabled &&
        this.uptodateReportObject.LobbyEdit.viewLobbyEditReports.Enabled &&
        this.uptodateReportObject.LobbyEdit.shareTemplateLobbyEditReports
          .Enabled &&
        this.uptodateReportObject.LobbyEdit.deleteTemplateLobbyEditReports
          .Enabled
      ) {
        this.uptodateReportObject.LobbyEdit.selectAll = isSelectAll;
      }
    }

    if (this.hasACLicense) {
      if (
        this.uptodateAppointmentsObject.Administration.ViewEditAdministration
          .Enabled &&
        this.uptodateAppointmentsObject.Administration.ViewEditEventSettings
          .Enabled
      ) {
        this.uptodateAppointmentsObject.Administration.selectAll = isSelectAll;
      }

      if (
        this.uptodateAppointmentsObject.Appointements.ExceptionsAdd.Enabled &&
        this.uptodateAppointmentsObject.Appointements.ExceptionsDelete
          .Enabled &&
        this.uptodateAppointmentsObject.Appointements.ExceptionsEdit.Enabled &&
        this.uptodateAppointmentsObject.Appointements.appointmentsAdd.Enabled &&
        this.uptodateAppointmentsObject.Appointements.appointmentsDelete
          .Enabled &&
        this.uptodateAppointmentsObject.Appointements.appointmentsEdit
          .Enabled &&
        this.uptodateAppointmentsObject.Appointements.appointmentsView.Enabled
      ) {
        this.uptodateAppointmentsObject.Appointements.selectAll = isSelectAll;
      }

      if (
        this.uptodateAppointmentsObject.Campaigns.EditCampaigns.Enabled &&
        this.uptodateAppointmentsObject.Campaigns.ViewCampaigns.Enabled
      ) {
        this.uptodateAppointmentsObject.Campaigns.selectAll = isSelectAll;
      }

      if (
        this.uptodateAppointmentsObject.Events.ActivateDeactivateEvents
          .Enabled &&
        this.uptodateAppointmentsObject.Events.AddEvents.Enabled &&
        this.uptodateAppointmentsObject.Events.EditEvents.Enabled &&
        this.uptodateAppointmentsObject.Events.ViewEvents.Enabled
      ) {
        this.uptodateAppointmentsObject.Events.selectAll = isSelectAll;
      }

      if (
        this.uptodateAppointmentsObject.Reports.viewAppointmentDetailsReport
          .Enabled &&
        this.uptodateAppointmentsObject.Reports.viewAppointmentTrendsReport
          .Enabled &&
        this.uptodateAppointmentsObject.Reports.viewCampaignSummaryReport
          .Enabled
      ) {
        this.uptodateAppointmentsObject.Reports.selectAll = isSelectAll;
      }

      if (
        this.uptodateAppointmentsObject.ViewActionCenter.bulkDeleteAppointments
          .Enabled &&
        this.uptodateAppointmentsObject.ViewActionCenter
          .changeAppointmentAssignment.Enabled &&
        this.uptodateAppointmentsObject.ViewActionCenter.changeAppointmentStatus
          .Enabled &&
        this.uptodateAppointmentsObject.ViewActionCenter.editActionCenter
          .Enabled &&
        this.uptodateAppointmentsObject.ViewActionCenter.sendFollowUpEnable
          .Enabled &&
        this.uptodateAppointmentsObject.ViewActionCenter.viewActionCenter
          .Enabled
      ) {
        this.uptodateAppointmentsObject.ViewActionCenter.selectAll =
          isSelectAll;
      }
    }

    // isSelectAll ===false ? this.uptodateAppointmentsObject.System.selectAll=false : this.uptodateAppointmentsObject.System.selectAll=true
    // isSelectAll ===false ? this.uptodateAppointmentsObject.SystemSettings.selectAll=false : this.uptodateAppointmentsObject.SystemSettings.selectAll=true

    this.valueChangeofSelectAllCommon();
    this.permissionSelected();
    this.isDirty = true;
  }

  private valueChangeofSelectAllCommon() {
    this.admin.selectAllGeneral();
    this.admin.selectAllClients();
    this.admin.selectAllLocations();
    this.admin.selectAllProductAndService();
    this.admin.selectAllViewAddEditProductCategories();
    this.admin.selectAllGroups();
    this.admin.selectAllUsers();
    this.admin.selectAllGlobalAlert();
    this.admin.selectAllKiosk();

    if (this.hasLTLicense) {
      this.lobby.selectAllChecklist();
      this.lobby.selectAllLobby();
      this.lobby.selectAllLwa();
      this.lobby.selectAllTextConfiguration();
    }

    if (this.hasLTLicense) {
      this.report.selectAllLobbyActivity();
      this.report.selectAllLobbyEdit();
    }

    if (this.hasACLicense) {
      this.appointment.selectAllActionCenter();
      this.appointment.selectAllGeneral();
      this.appointment.selectAllReports();
      this.appointment.selectAllSystemSettings();
      this.appointment.onAdminSelectAll();
      this.appointment.onEventsSelectAll();
      this.appointment.onCampaignsSelectAll();
    }
  }

  checkSectionsSelectAll() {
    if (this.hasACLicense && !this.hasLTLicense) {
      if (
        this.uptodateAdminObject.selectAllPermissionAdmin.Selected &&
        this.uptodateAppointmentsObject.selectAllPermissionAppointments.Selected
      ) {
        this.permissionGroupEdit.patchValue({ selectAllPermissions: true });
      } else {
        this.permissionGroupEdit.patchValue({ selectAllPermissions: false });
      }
    }

    if (!this.hasACLicense && this.hasLTLicense) {
      if (
        this.uptodateAdminObject.selectAllPermissionAdmin.Selected &&
        this.uptodateLobbyObject.selectAllPermissionLobby.Selected &&
        this.uptodateReportObject.selectAllPermissionReport.Selected
      ) {
        this.permissionGroupEdit.patchValue({ selectAllPermissions: true });
      } else {
        this.permissionGroupEdit.patchValue({ selectAllPermissions: false });
      }
    }

    if (this.hasACLicense && this.hasLTLicense) {
      if (
        this.uptodateAdminObject.selectAllPermissionAdmin.Selected &&
        this.uptodateLobbyObject.selectAllPermissionLobby.Selected &&
        this.uptodateReportObject.selectAllPermissionReport.Selected &&
        this.uptodateAppointmentsObject.selectAllPermissionAppointments.Selected
      ) {
        this.permissionGroupEdit.patchValue({ selectAllPermissions: true });
      } else {
        this.permissionGroupEdit.patchValue({ selectAllPermissions: false });
      }
    }
  }

  onSectionSelectAll(e: boolean) {
    this.checkSectionsSelectAll();
  }

  get hoverOverMessageOnNotificationGroupCheckbox(): string {
    const notAllowedMsg =
      "Unchecking 'Notification Group' checkbox is not allowed because this notification group is configured as the default selected person/group in Kiosk(s).";

    if (this.isViewOnly) {
      //if the edit is view only, no messages will be shown on title
      return "";
    }

    return !this.canUncheckNotification ? notAllowedMsg : "";
  }

  private setUniversalSelectAllStatus(
    allPermissionReferencesData: any[]
  ): boolean {
    let allPermissionReferencesEnabled = allPermissionReferencesData.filter(
      (f) => f.enabled == false
    );

    if (allPermissionReferencesEnabled.length > 0) {
      let allPermissionReferencesInUse = allPermissionReferencesEnabled.filter(
        (f) =>
          f.permissionId !== 2 &&
          f.permissionId !== 5 &&
          f.permissionId !== 22 &&
          f.permissionId !== 23 &&
          f.permissionId !== 24 &&
          f.permissionId !== 25 &&
          f.permissionId !== 26 &&
          f.permissionId !== 78 &&
          f.permissionId !== 79 &&
          f.permissionId !== 80 &&
          f.permissionId !== 81 &&
          f.permissionId !== 92 &&
          f.permissionId !== 93 &&
          f.permissionId !== 94 &&
          f.permissionId !== 95 &&
          f.permissionId !== 96 &&
          f.permissionId !== 97 &&
          f.permissionId !== 98 &&
          f.permissionId !== 99 &&
          f.permissionId !== 100 &&
          f.permissionId !== 101 &&
          f.permissionId !== 102 &&
          f.permissionId !== 103 &&
          f.permissionId !== 104 &&
          f.permissionId !== 105 &&
          f.permissionId !== 61 &&
          f.permissionId !== 71 &&
          f.permissionId !== 73
      );

      if (allPermissionReferencesInUse.length > 0) {
        return true;
      }
    }

    return false;
  }

  /**
   * Maps all permission objects Id that needs to be removed to Array
   * @returns
   */
  public mapRemovePermissions() {
    // Admin
    this.analyzePermissionToRemove(this.uptodateAdminObject.General, null, [
      "viewEditSystemConfiguration",
      "viewEditLocalization",
      "dataImportExport",
    ]);

    //General.viewEditLicensing is allowed on the default client (with tenantId = 1)
    this.analyzePermissionToRemove(
      this.uptodateAdminObject.General,
      this.tenantId,
      ["viewEditLicensing"]
    );

    this.analyzePermissionToRemove(this.uptodateAdminObject.Location);
    this.analyzePermissionToRemove(
      this.uptodateAdminObject.ViewAddEditDeleteProductCategory
    );
    this.analyzePermissionToRemove(this.uptodateAdminObject.ProductAndService);
    this.analyzePermissionToRemove(this.uptodateAdminObject.Groups);
    this.analyzePermissionToRemove(this.uptodateAdminObject.Users);
    this.analyzePermissionToRemove(this.uptodateAdminObject.Members);

    // this set of permissions is allowed on the default client (with tenantId = 1)
    this.analyzePermissionToRemove(
      this.uptodateAdminObject.Clients,
      this.tenantId
    );

    if (this.hasLTLicense) {
      // Admin
      this.analyzePermissionToRemove(this.uptodateAdminObject.ViewGlobalAlerts);
      this.analyzePermissionToRemove(this.uptodateAdminObject.Kiosk);
      // Lobby
      this.analyzePermissionToRemove(this.uptodateLobbyObject.General);
      this.analyzePermissionToRemove(this.uptodateLobbyObject.Checklist);
      this.analyzePermissionToRemove(this.uptodateLobbyObject.Lwa);
      // Reports
      this.analyzePermissionToRemove(
        this.uptodateLobbyObject.TextConfiguration
      );
      this.analyzePermissionToRemove(this.uptodateReportObject.LobbyActivity);
      this.analyzePermissionToRemove(this.uptodateReportObject.LobbyEdit);
    }

    if (this.hasACLicense) {
      // Appointments
      this.analyzePermissionToRemove(
        this.uptodateAppointmentsObject.Administration
      );
      this.analyzePermissionToRemove(
        this.uptodateAppointmentsObject.Appointements
      );
      this.analyzePermissionToRemove(
        this.uptodateAppointmentsObject.ViewActionCenter
      );
      this.analyzePermissionToRemove(this.uptodateAppointmentsObject.Campaigns);
      this.analyzePermissionToRemove(this.uptodateAppointmentsObject.Events);
      this.analyzePermissionToRemove(this.uptodateAppointmentsObject.Reports);
    }

    return this.permissionListToRemove;
  }

  private analyzePermissionToRemove(
    permission: Record<string, any>,
    tenantId?: number | null,
    lncludelist?: string[]
  ) {
    if (lncludelist != null) {
      for (const subPermission in permission) {
        if (tenantId != null) {
          if (
            permission.hasOwnProperty(subPermission) &&
            !permission[subPermission].Selected &&
            permission[subPermission].Enabled &&
            lncludelist.includes(subPermission) &&
            tenantId == 1
          ) {
            this.permissionListToRemove.push(permission[subPermission].Id);
          }
        } else {
          if (
            permission.hasOwnProperty(subPermission) &&
            !permission[subPermission].Selected &&
            permission[subPermission].Enabled &&
            lncludelist.includes(subPermission)
          ) {
            this.permissionListToRemove.push(permission[subPermission].Id);
          }
        }
      }
    } else {
      for (const subPermission in permission) {
        if (tenantId != null) {
          if (
            permission.hasOwnProperty(subPermission) &&
            !permission[subPermission].Selected &&
            permission[subPermission].Enabled &&
            tenantId == 1
          ) {
            this.permissionListToRemove.push(permission[subPermission].Id);
          }
        } else {
          if (
            permission.hasOwnProperty(subPermission) &&
            !permission[subPermission].Selected &&
            permission[subPermission].Enabled
          ) {
            this.permissionListToRemove.push(permission[subPermission].Id);
          }
        }
      }
    }
  }
}
